<template>
  <div v-if="controls===true">
    <div>Live: {{ isActive }}</div>
    <div>
      <button @click="pause">
        pause
      </button>
      <button @click="resume">
        resume
      </button>
    </div>
  </div>
</template>

<script setup>
    import { ref,toRefs,inject } from 'vue'
    import { useTimeoutPoll } from '@vueuse/core'
    import { gatedFetch } from '@/services/gatedFetch.js'
    const props = defineProps({ src: String, scanrate: Number, controls: Boolean });
    const { src, scanrate } = toRefs(props);
    const emit = defineEmits(['on-data']);
    const reportsBase = inject('reportsBase');
    const archiveBase = inject('archiveBase');
    // Report-server URLs sit behind the login gate; other hosts (e.g. the build monitor) keep a plain fetch.
    const isReportUrl = (u) => u.startsWith(reportsBase) || u.startsWith(archiveBase);
    async function fetchData() {
      const url = src.value;
      if(url !== '') {
        (isReportUrl(url) ? gatedFetch : fetch)(url, {
          headers: { 'Content-type': 'application/json' },
        }).then((res) => res.json()).then((response) => {
          emit('on-data',response);
        }).catch((error) => {
          emit('on-data',-1);
        });
      } else {
        emit('on-data',-2);
      }
    }
    const { isActive, pause, resume } = useTimeoutPoll(fetchData, scanrate.value, {immediate:true});

</script>
